import React from 'react';

const StepsComponents = ({ current, Components, props }) => {
    const Component = Components[current];
  
    return <Component {...props} />
}

export default StepsComponents;